import { ArgumentError } from '../utils/errors';
import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';

export default class RedditonModel extends BaseAPIModel {
    getUrlTmp({ organizationId, eventId = null }, queryParams) {
        const url = `${this.constructor.listUrlTmp({ eventId, organizationId })}`;
        return fetcher.post(url, { data: queryParams }).then(({ response }) => {
            this.data_url = response;
            return this;
        });
    }

    static listUrlTmp({ organizationId, eventId }) {
        if (!eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/reddition/download/${eventId}/temp.pdf`;
    }

    getUrl({ organizationId, eventId = null }, queryParams) {
        const url = `${this.constructor.listUrl({ organizationId, eventId })}`;
        return fetcher.post(url, { formData: queryParams }).then(({ response }) => {
            this.data_url = response;
            return this;
        });
    }

    static listUrl({ organizationId, eventId }) {
        if (!eventId) {
            throw new ArgumentError(`[Model][AttendeeModel][getAll] organizationId and eventId are mandatory`);
        }

        return `/ticket/organizations/${organizationId}/accountancy/reddition/download/${eventId}/complete.pdf`;
    }
}
